require('./hirePackOpenYoungStep6.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLastNChars } = require('utilities/stringHelper');

//@commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const HireOpenYoungSummary = require('components/hire/hireOpenYoungSummary/hireOpenYoungSummary');
const WebappRender = require('components/conditionalRender/webappRender');

// @constants
const {
    API_CENTER,
    API_ENTERPRISE_NUMBER,
    OPENYOUNG_ACCOUNT_STANDARD,
    OPENYOUNG_ACCOUNT_SUBTYPE,
    OPENYOUNG_ACCOUNT_TYPE,
} = require('constants/index');
const {
    ACCOUNT_OPEN_YOUNG_OPERATION_CODE,
    ADD_NEW_SHIPPING_ADDRESS,
    CARD_OPEN_YOUNG_CREDIT_OPERATION_CODE,
    CARD_OPEN_YOUNG_OPERATION_CODE,
    MULTIPLE_OPERATIONS,
    messages: { PACK_OPEN_YOUNG_HIRE },
} = require('constants/operationTypes');
const {
    OPENYOUNG_CARD_STANDARD,
    OPENYOUNG_CARD_SUBTYPE,
    OPENYOUNG_CARD_TYPE,
    SIXTH_STEP,
} = require('constants/index');
const {
    CONFIRMATION_SCRIPT_AGREEMENT,
    CONFIRMATION_SCRIPT_GREETING,
    ConfirmationScript,
} = require('components/contactCenter/confirmScript/confirmationScript');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const {
    OPEN_YOUNG_ACCOUNT_PRODUCT_NAME,
    OPEN_YOUNG_CARD_PRODUCT_NAME,
} = require('constants/cardsPrecontractualMailInfo');
const { OPEN_YOUNG_PACK_PRODUCT_MIN_ALIAS } = require('constants/hiringProductInformation');

class HirePackOpenYoungStep6 extends React.Component {
    componentDidMount() {
        const { sendPrecontractualDocumentMail } = this.props;
        const precontractualMailProductInfo = {
            productAlias: OPEN_YOUNG_PACK_PRODUCT_MIN_ALIAS,
            productName: OPEN_YOUNG_ACCOUNT_PRODUCT_NAME,
            producto: OPENYOUNG_ACCOUNT_TYPE,
            productsRelated: [{
                productName: OPEN_YOUNG_CARD_PRODUCT_NAME,
                producto: OPENYOUNG_CARD_TYPE,
                standard: OPENYOUNG_CARD_STANDARD,
                subproducto: OPENYOUNG_CARD_SUBTYPE,
            }],
            standard: OPENYOUNG_ACCOUNT_STANDARD,
            subproducto: OPENYOUNG_ACCOUNT_SUBTYPE,
        };

        sendPrecontractualDocumentMail(precontractualMailProductInfo);

        if (!__CONTACT_CENTER__) {
            //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
            this.props.setTermsAndCondsText('hirePackOpenYoung-hirePackOpenYoung_confirmationStepAgreementText');
        }
    }

    buildAsociatedAccount() {
        const {
            immAccounts,
            selectedAccount,
        } = this.props;

        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountIban = getLastNChars(immAccount.get('iban'));
        return (
            <div>
                <span>{immAccount.get('alias')}</span>
                &nbsp;
                <span>{accountIban}</span>
            </div>
        );
    }

    buildLegalRepresentatives() {
        const { immHireOpenYoungInterveners } = this.props;

        const interveners = immHireOpenYoungInterveners.get('list').map((immIntervener, index) => (
            <li
                className="hire-pack-open-young-step-six__list-item"
                key={index}
            >
                {immIntervener.get('name')}
            </li>
        ));

        return (
            <ul className="hire-pack-open-young-step-six__list-container">
                {interveners}
            </ul>
        );
    }

    render() {
        const {
            immAccounts,
            immHirePackOpenYoung,
            immOpenYoungPersonalData,
            immPdfData,
            immShippingAddress,
            operativeName,
            printTitleValue,
            selectedAccount,
        } = this.props;

        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const immStep6 = immHirePackOpenYoung.getIn(['steps', SIXTH_STEP]);

        const operationParams = {
            id: PACK_OPEN_YOUNG_HIRE,
                requestMulti: [
                    {
                        serviceCode: ACCOUNT_OPEN_YOUNG_OPERATION_CODE,
                        originAccount: API_ENTERPRISE_NUMBER + API_CENTER + immAccount.get('product') + immAccount.get('contractNumber'),
                    },
                    {
                        serviceCode: CARD_OPEN_YOUNG_OPERATION_CODE,
                    },
                    {
                        serviceCode: CARD_OPEN_YOUNG_CREDIT_OPERATION_CODE,
                    },
                    {
                        serviceCode: ADD_NEW_SHIPPING_ADDRESS
                    }
            ]
        };

        const agreementLabel = <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_confirmationStepAgreementText" />;
        const agreementChecked = immStep6.get('agreementChecked');
        const agreementErrorVisible = immStep6.get('agreementIsDirty') && !immStep6.get('agreementChecked');
        const agreementErrorMsg = formatText('hirePackOpenYoung-hirePackOpenYoung_step5CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const minorName = immOpenYoungPersonalData.getIn(['name', 'value']);
        const minorLastName = immOpenYoungPersonalData.getIn(['lastName', 'value']);
        const minorLastName2 = immOpenYoungPersonalData.getIn(['lastName2', 'value']);
        const minorFullName = `${minorName} ${minorLastName} ${minorLastName2}`;
        const asociatedAccount = this.buildAsociatedAccount();
        const shippingAddress = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);
        const legalRepresentatives = this.buildLegalRepresentatives();
        const preContractDocumentInfo = getCardsPreContractPdfData()['open_young_card_account_package'];

        let agreementCheckboxContent, GDPRSignaturePatternContent;

        if(!pdfError) {
            agreementCheckboxContent = (
                <div className="hire-pack-open-young-step-six__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hirePackOpenYoungAgreementCheckbox"
                            errorState={agreementErrorVisible}
                            errorMessage={agreementErrorMsg}
                            label={agreementLabel}
                            onChange={this.props.handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <SignaturePattern
                    operationParams={operationParams}
                    operationType={MULTIPLE_OPERATIONS}
                    printTitleValue={printTitleValue}
                />
            )
        }

        return (
            <article className="hire-pack-open-young-step-six" id="printable-wizard">
                <FormattedText
                    className="hire-pack-open-young-step-six__title print-title"
                    value="hirePackOpenYoung-hirePackOpenYoung_step5Title"
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText(operativeName)}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>
                <FormattedText
                    className="hire-pack-open-young-step-six__subtitle"
                    value="hirePackOpenYoung-hirePackOpenYoung_step5Subtitle"
                />
                <HireOpenYoungSummary
                    asociatedAccount={asociatedAccount}
                    legalRepresentative={legalRepresentatives}
                    name={minorFullName}
                    shippingAddress={shippingAddress}
                />
                <WebappRender>
                    <div className="hire-pack-open-young-step-six__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractDocumentInfo}
                            titleKey="preContractDocument_pdfTitlePackOpenYoung"
                        />
                    </div>
                </WebappRender>
                {agreementCheckboxContent}
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                {GDPRSignaturePatternContent}
            </article>
        );
    }
}

HirePackOpenYoungStep6.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireOpenYoungInterveners: PropTypes.object.isRequired,
    immHirePackOpenYoung: PropTypes.object.isRequired,
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    operativeName: PropTypes.string,
    printTitleValue: PropTypes.string,
    selectedAccount: PropTypes.string.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = HirePackOpenYoungStep6;
